import axios from 'axios';
import getHeaders from '../../constants/headers';
import { CONSUMER_BASE_URL } from '../BaseURL';

export const getBrandBanner = (brandId) => {
  return axios({
    method: "get",
    url: CONSUMER_BASE_URL + "/api/secure/v1/brand-banner-by-admin/" + brandId,
    headers: getHeaders(),
  });
};

export const addBrandBanner = (brandId, location, image) => {
  const formData = new FormData();
  formData.append("fileData", image); // Assuming 'file' is the file object you want to upload

  return axios({
    method: "post",
    url:
      CONSUMER_BASE_URL +
      "/api/secure/v1/brand-banner-upload/" +
      brandId +
      "/" +
      location, // for android use
    data: formData,
    headers: getHeaders("multipart/form-data"),
  });
};

export const updateBrandBanner = (brandId, bannerId, image) => {
  const formData = new FormData();
  formData.append("fileData", image); // Assuming 'file' is the file object you want to upload

  return axios({
    method: "post",
    url:
      CONSUMER_BASE_URL +
      "/api/secure/v1/brand-banner-update/" +
      brandId +
      "/" +
      bannerId, // for android use
    data: formData,
    headers: getHeaders("multipart/form-data"),
  });
};

export const updateBrandBannerStatus = (brandId, bannerId) => {
  return axios({
    method: "put",
    url:
      CONSUMER_BASE_URL +
      "/api/secure/v1/brand-banner/" +
      brandId +
      "/banner/" +
      bannerId +
      "/status",
    headers: getHeaders(),
  });
};

export const getBrandBannerImage = (imageCode) => {
  return axios({
    method: "get",
    url: CONSUMER_BASE_URL + "/api/secure/v1/brand-banner-by-code/" + imageCode,
    headers: getHeaders(),
  });
};

// export const viewBrandBanner = (brandId, bannerCode) => {
//   return axios({
//     method: "get",
//     url:
//       CONSUMER_BASE_URL +
//       "/api/secure/v1/brand-banner-by-code/" +
//       brandId +
//       "/" +
//       bannerCode,
//     headers: getHeaders(),
//   });
// };

// export const viewBrandBanner = (brandId) => {
//   return axios({
//     method: "get",
//     url:
//       CONSUMER_BASE_URL +
//       "/api/secure/v1/brand-banner-by-admin/" +
//       brandId,
//     headers: getHeaders(),
//   });
// };